import { Link } from "react-router-dom";

interface SectionHeaderProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}